<template>
  <base-dialog v-model="dialog.show" max-width="500px" min-width="300px" scrollable
    :title="`${titleDialog} trường dữ liệu`" width="50%">
    <base-form ref="form" lazy-validation @submit.stop="onSubmit">
      <v-row no-gutters v-if="dialog.data.type == 'reference'">
        <v-col cols="12">
          <field-group v-model="dialog.data.name" autofocus :error-messages="dialog.error.name" filled label="Tên"
            no-label></field-group>
        </v-col>
      </v-row>
      <v-row no-gutters v-else>
        <v-col cols="12">
          <field-group v-model="dialog.data.name" autofocus :error-messages="dialog.error.name" filled label="Tên"
            no-label></field-group>
        </v-col>
        <v-col cols="12">
          <field-group v-model="dialog.data.code" :error-messages="dialog.error.code" filled label="Mã"
            :readonly="!isCreateDialog" no-label></field-group>
        </v-col>
        <v-col cols="12">
          <field-group v-model="dialog.data.type" :error-messages="dialog.error.type" filled
            :readonly="dialog.data.static || !isCanChangeType" no-label label="Kiểu dữ liệu" @input="onChangeType"
            :items="itemsType" type-input="v-select"></field-group>
        </v-col>
        <v-col cols="12">
          <field-group v-model="dialog.data.description" autofocus :error-messages="dialog.error.description" filled
            label="Chi tiết" no-label type-input="v-textarea" rows="2" no-resize></field-group>
        </v-col>
        <v-col cols="12">
          <v-switch class="ml-2" v-model="dialog.data.visibility['browse']" inset label="Hiển thị"></v-switch>
        </v-col>
        <v-col cols="12">
          <v-switch class="ml-2" v-model="dialog.data.visibility['inShowMore']" inset>
            <template v-slot:label>
              <span>Ẩn trong </span><span style="font-weight: bold; padding-left: 5px;">"Xem thêm"</span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" dark v-bind="attrs" v-on="on" class="ml-4">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <div>
                  Trường dữ liệu này sẽ được ẩn đi tại THÔNG TIN THUỘC TÍNH, trên bản đồ.
                  <div class="d-flex align-center">
                    <div>Người dùng cần nhấn vào </div>
                    <div style="background: #ECEFF1; color: black; border-radius: 6px;" class="pl-1 pr-2 mr-1 ml-1">
                      <v-icon medium color="darken-2">
                        mdi-chevron-down
                      </v-icon> Xem thêm
                    </div>
                    <div>
                      để xem thông tin trường này
                    </div>
                  </div>
                </div>
              </v-tooltip>
            </template></v-switch>
        </v-col>
        <!-- <v-col cols="12">
          <v-switch
            class="ml-2"
            v-model="dialog.data.required"
            inset
            label="Bắt buộc"
          ></v-switch>
        </v-col> -->
        <!-- <v-col cols="12" v-if="dialog.data.type == 'string'">
          <field-group
            v-model="dialog.data.meta.max"
            label="Độ dài tối đa"
            filled
            no-label
          ></field-group>
        </v-col> -->
        <FieldArrayConfig v-model="dialog.data.meta" v-if="dialog.data.type == 'array'"></FieldArrayConfig>
        <!-- <template v-if="dialog.data.type != 'geometry'">
          <v-col cols="12" v-if="dialog.data.type == 'boolean'">
            <v-switch
              class="ml-2"
              v-model="dialog.data.meta.defaultValue"
              inset
              label="Mặc định"
            ></v-switch>
          </v-col>
          <v-col cols="12" v-else>
            <field-group
              v-model="dialog.data.meta.defaultValue"
              :error-messages="dialog.error.field_type"
              filled
              no-label
              label="Mặc định"
              :items="items"
              type-input="v-select"
            >
            </field-group>
          </v-col>
        </template> -->
      </v-row>
    </base-form>
    <template v-slot:extra-btn>
      <base-button color="primary" :loading="dialog.loading" outlined :type-action="dialog.type" @click="onSubmit">
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { API_FIELD } from '@api'
import { EDIT_TYPE, FIELD_TYPE_EDIT } from '@constant'
import { merge } from 'lodash'
import FieldArrayConfig from './config/field-array-config.vue'
export default {
  components: { FieldArrayConfig },
  data: () => ({
    dialog: {
      show: false,
      loading: false,
      data: {
        meta: {
          field: {},
          defaultValue: null,
        },
        visibility: {},
      },
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    type_: 'v-text-field',
    headers_domain: [
      {
        text: 'Giá trị',
        align: 'start',
        sortable: true,
        value: 'value',
      },
      {
        text: 'Hiển thị',
        align: 'start',
        sortable: true,
        value: 'text',
      },
      {
        text: 'Mã',
        align: 'start',
        sortable: true,
        value: 'code',
      },
    ],
  }),
  watch: {},
  computed: {
    isCanChangeType() {
      return !['array', 'geometry'].includes(this.dialog.data.type)
    },
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    itemsType(vm) {
      return FIELD_TYPE_EDIT.map((x) => ({
        text: vm.$t(`property.type.${x}`),
        value: x,
      }))
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  methods: {
    onChangeType() {
      this.dialog.data.meta = {
        field: {},
      }
    },
    open(item, type) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.dialog.type = type
      let data = merge({ meta: { field: {}, items: [] }, visibility: {} }, item)
      delete data.created_at
      delete data.updated_at
      this.dialog.data = Object.assign({}, data)
    },
    dialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: { thuoc_tinh: { items: [] } },
        type: EDIT_TYPE.CREATE,
        error: {},
      }
    },
    async onSubmit() {
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        let data = Object.assign({}, this.dialog.data)

        let res = await API_FIELD.update(data.id, data)

        if (res && !res.error) {
          this.dialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.error = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
  },
}
</script>

<style scoped></style>
